import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { UserSession } from 'dashboard/models/user-session';
import {
  setCurrentPage,
  setUserSessions,
  UserSessionsFilterParams,
} from 'dashboard/redux/actions/user-sessions';
import { DashboardThunkAction } from 'dashboard/redux/types';
import { ApiEndpoint, ApiModel, ApiSingletonPayload, PaginationParams } from 'lib/interfaces/api';

export interface TableParams {
  currentPage: number;
  pageSize: number;
  filters: UserSessionsFilterParams;
}

export function loadUserSessionList({
  currentPage,
  pageSize,
  filters,
}: TableParams): DashboardThunkAction<Promise<void>> {
  return async (dispatch) => {
    const paramsFull = {
      ...createParamsForUserSessions(filters),
      page: {
        number: currentPage,
        size: pageSize,
      },
    };

    const { data: userSessions, meta: paginationParams } =
      await SessionClientDashboard.listResource<UserSession, PaginationParams>(
        ApiEndpoint.UserSession,
        paramsFull,
      );

    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    dispatch(setUserSessions(userSessions, paginationParams));
  };
}

export function expireSession(
  userSessionId: string,
  tableParams: TableParams,
): DashboardThunkAction {
  return async (dispatch, ...args) => {
    await SessionClientDashboard.postResourceAction<UserSession>(
      { type: ApiModel.UserSession, id: userSessionId },
      'expire',
    );
    await loadUserSessionList(tableParams)(dispatch, ...args);
  };
}

export function expireSessionsForUsers(
  userIds: string[],
  tableParams: TableParams,
): DashboardThunkAction {
  return async (dispatch, ...args) => {
    await SessionClientDashboard.postResourceSingletonAction<
      UserSession,
      ApiSingletonPayload<{}, ApiModel.UserSession>
    >(
      {
        type: ApiModel.UserSession,
      },
      'bulk-expire',
      {
        filter: {
          'user-id': userIds,
        },
      },
    );
    // Reset current page since this is likely to change the total page size
    dispatch(setCurrentPage(1));
    await loadUserSessionList({ ...tableParams, currentPage: 1 })(dispatch, ...args);
  };
}

function createParamsForUserSessions(filters: UserSessionsFilterParams) {
  const { status, createdAtStart, createdAtEnd, userIds } = filters;

  return {
    filter: {
      status,
      'created-at-start': createdAtStart && createdAtStart.toString(),
      'created-at-end': createdAtEnd && createdAtEnd.toString(),
      'user-id': userIds,
    },
  };
}
